const defaultState = {
  directMessages: null,
}

export default defaultState
